var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26112_43083)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26112_43083)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2467 15.1146C29.1778 15.1146 29.9326 15.8795 29.9326 16.823V25.3649C29.9326 26.3084 29.1778 27.0732 28.2467 27.0732H14.7596C13.8285 27.0732 13.0737 26.3084 13.0737 25.3649V24.7648L25.9697 24.7658C26.8491 24.7658 27.5712 24.0836 27.6487 23.2129L27.6556 23.0574L27.6547 15.1146H28.2467Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8579 17.5456L26.8589 22.2502C26.8589 23.1937 26.1041 23.9586 25.1731 23.9586H11.6859C10.7548 23.9586 10 23.1937 10 22.2502L10 17.5456H26.8579ZM25.1731 12C26.1041 12 26.8589 12.7649 26.8589 13.7084L26.8579 14.2176H10L10 13.7084C10 12.7649 10.7548 12 11.6859 12H25.1731Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8589 14.9952H10V16.7702H26.8589V14.9952Z",
    fill: "#4251DA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26112_43083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26112_43083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(10 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentResults);
export default __webpack_public_path__ + "static/media/payment-results.b5cdc8210b42dffcbd926a570d6f0bdb.svg";
export { ForwardRef as ReactComponent };